import $ from 'jquery';
import SearchModuleUtil from '@lts-web/utils/SearchModuleUtil';
import SyncFormUtil from '@lts-web/utils/SyncFormUtil';
import FormData, { messages, helpers, validators } from '@lts-web/data-objects/FormData';
import * as dataSets from '@lts-web/schemas/formDataSets';

$.SyncFormUtil = function (moduleName, moduleConvention = 'NMC') {
    if (moduleConvention !== 'NMC')
        moduleName = SearchModuleUtil.convertModule(moduleName, moduleConvention, 'NMC');

    return SyncFormUtil.findFormData(moduleName);
};

$.SyncFormUtil.createForm = SyncFormUtil.createFormData;
$.SyncFormUtil.getForm = SyncFormUtil.getFormData;
$.SyncFormUtil.hasForm = SyncFormUtil.hasFormData;
$.SyncFormUtil.data = SyncFormUtil.useDataSet;
$.SyncFormUtil.validate = SyncFormUtil.validate;
$.SyncFormUtil.getKeys = SyncFormUtil.getDataKeys;

class DataForm extends FormData {}

DataForm.dataSets = dataSets;
DataForm.messages = messages;
DataForm.helpers = helpers;
DataForm.validators = validators;

global.DataForm = DataForm;